function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';

function SvgComponent({
  height,
  width,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 15",
    width: width,
    height: height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M.996 7.481a.253.253 0 01.087-.346 50.878 50.878 0 0112.315-5.3l.117-.032a.264.264 0 01.298.118l3.43 5.734a.65.65 0 01-.385.96l-1.987.549a27.05 27.05 0 00-6.26 2.612l-3.47 1.992a.337.337 0 01-.456-.12L.995 7.482z",
    fill: "#DAF0ED",
    stroke: "#828A90",
    strokeWidth: ".7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.32 7.642c-.036.216-.22.45-.53.626-.305.174-.659.247-.924.204-.08-.013-.195-.072-.334-.211a2.284 2.284 0 01-.381-.535 2.955 2.955 0 01-.254-.653 1.337 1.337 0 01-.047-.506c.036-.223.172-.377.39-.473.23-.102.538-.132.848-.081.105.017.246.08.405.2.156.117.312.275.448.455.135.179.243.37.31.548.069.182.085.327.069.426z",
    fill: "#fff",
    stroke: "#828A90",
    strokeWidth: ".7"
  }));
}

SvgComponent.defaultProps = {
  width: 19,
  height: 15
};
SvgComponent.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default SvgComponent;